import { Navigate, RouteObject } from 'react-router-dom';
import MainLayout from '../layouts/main/main-layout';
import AuthCallback from '../modules/auth/pages/auth-callback/auth-callback';
import Login from '../modules/auth/pages/login/login';
import Logout from '../modules/auth/pages/logout/logout';
import ClientGroups from '../modules/client-groups/pages/client-groups/client-groups';
import ClientUserTraceLogs from '../modules/client-users/pages/client-user-trace-logs/client-user-trace-logs';
import ClientUsers from '../modules/client-users/pages/client-users/client-users';
import Main from '../modules/main/pages/main';
import CurrentUserDetails from '../modules/user/pages/current-user-details/current-user-details';
import CurrentUserTraceLogs from '../modules/user/pages/current-user-trace-logs/current-user-trace-logs';
import CustomersTraceLogs from '../modules/customers/pages/customer-trace-logs/customer-trace-logs';
import Customers from '../modules/customers/pages/customers/customers';
import Dashboard from '../modules/dashboard/pages/dashboard/dashboard';
import ScanRequestTraceLogs from '../modules/scan-requests/pages/scan-request-trace-logs/scan-request-trace-logs';
import ScanRequest from '../modules/scan-requests/pages/scan-request/scan-request';
import ScanRequests from '../modules/scan-requests/pages/scan-requests/scan-requests';
import SignRequestTraceLogs from '../modules/sign-requests/pages/sign-request-trace-logs/sign-request-trace-logs';
import SignRequest from '../modules/sign-requests/pages/sign-request/sign-request';
import SignRequests from '../modules/sign-requests/pages/sign-requests/sign-requests';
import { Routes } from './routes';

export const routesConfig: RouteObject[] = [
  {
    path: Routes.Main,
    element: <Main />,
  },
  {
    path: Routes.Login,
    element: <Login />,
  },
  {
    path: Routes.Logout,
    element: <Logout />,
  },
  {
    path: Routes.OauthCallback,
    element: <AuthCallback />,
  },
  {
    element: <MainLayout />,
    children: [
      {
        path: Routes.Dashboard,
        element: <Dashboard />,
      },
      {
        path: Routes.SignRequests,
        element: <SignRequests />,
      },
      {
        path: Routes.SignRequestTraceLogs,
        element: <SignRequestTraceLogs />,
      },
      {
        path: Routes.SignRequest,
        element: <SignRequest />,
      },
      {
        path: Routes.ScanRequests,
        element: <ScanRequests />,
      },
      {
        path: Routes.ScanRequestTraceLogs,
        element: <ScanRequestTraceLogs />,
      },
      {
        path: Routes.ScanRequest,
        element: <ScanRequest />,
      },
      {
        path: Routes.Customers,
        element: <Customers />,
      },
      {
        path: Routes.ClientUsers,
        element: <ClientUsers />,
      },
      {
        path: Routes.ClientGroups,
        element: <ClientGroups />,
      },
      {
        path: Routes.CustomerTraceLogs,
        element: <CustomersTraceLogs />,
      },
      {
        path: Routes.ClientUserTraceLogs,
        element: <ClientUserTraceLogs />,
      },
      {
        path: Routes.UserTraceLogs,
        element: <CurrentUserTraceLogs />,
      },
      {
        path: Routes.UserDetails,
        element: <CurrentUserDetails />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate replace to={Routes.Dashboard} />,
  },
];
